import React from 'react';
import Stats from './Stats';
import DashboardSCORMFiles from './DashboardSCORMFiles';

const Dashboard = () => {
    return (
        <>
            {/* Campaign Stats */}
            <Stats />

            {/* SCORM Files Table */}
            <DashboardSCORMFiles />
        </>
    );
};

export default Dashboard;
